import { createLocationReviewIndex } from './locationStatusFilters';

export const userReviewEmailKey = (email) => String(email || '').trim().toLocaleLowerCase();

export function createUserLocationStatusIndex(userStatuses) {
  const groups = new Map();
  for (const entry of userStatuses || []) {
    const email = userReviewEmailKey(entry.userEmail);
    if (!groups.has(email)) groups.set(email, []);
    groups.get(email).push(entry);
  }
  return new Map([...groups].map(([email, statuses]) => [email, {
    statuses, review: createLocationReviewIndex(statuses),
  }]));
}
